import { COL_PEEK_DIMENSIONS } from './styles';

const OFFSET_PADDING = 20;
const OFFSET_LEFT = 100;

export function calculateLeft(initialLeft: number) {
    let calculatedLeft = initialLeft - OFFSET_LEFT;
    const rightEdge = calculatedLeft + COL_PEEK_DIMENSIONS.width;

    // if the component is off the page to the right, then recalculate calculatedLeft
    if (rightEdge + OFFSET_PADDING > window.innerWidth) {
        const overlap = rightEdge - window.innerWidth;
        calculatedLeft = calculatedLeft - (overlap + OFFSET_PADDING);
    }

    // if the component is off the page to the left, then recalculate calculatedLeft
    if (calculatedLeft < OFFSET_PADDING) {
        const overlap = Math.abs(calculatedLeft);
        calculatedLeft = calculatedLeft + overlap + OFFSET_PADDING;
    }

    return calculatedLeft;
}

export function calculateTop(initialTop: number, height) {
    let calculatedTop = initialTop + height + OFFSET_PADDING + window.scrollY;
    const bottomEdge = calculatedTop + COL_PEEK_DIMENSIONS.height;

    // if the component is off the page to the bottom, then recalculate calculatedTop
    const bottomOfVisiblePage = window.innerHeight + window.scrollY;

    if (bottomEdge > bottomOfVisiblePage - OFFSET_PADDING) {
        calculatedTop = initialTop + window.scrollY - height - COL_PEEK_DIMENSIONS.height - OFFSET_PADDING;
    }

    return calculatedTop;
}

export const formatFloorPrice = (usd): string => {
    if (usd) {
        const digits = Math.round(usd).toString().length;
        if (digits > 4) {
            return usd.toLocaleString('en-US', {
                currency: 'USD',
                style: 'currency',
                notation: 'compact',
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
            });
        }
        return usd.toLocaleString('en-US', {
            currency: 'USD',
            style: 'currency',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    }

    return '';
};
